import { DatePicker } from 'antd';
import type { DatePickerProps } from 'antd';
import clsx from 'clsx';
import styles from './WorkOrderDatePicker.module.scss';

export const WORK_ORDER_DATE_FORMAT = 'MMMM D, YYYY';

// Shared by the filter and the Create/Edit forms; caller classes are merged, never replaced.
const WorkOrderDatePicker = ({ className, popupClassName, ...props }: DatePickerProps) => (
  <DatePicker
    format={WORK_ORDER_DATE_FORMAT}
    placeholder="Select date"
    suffixIcon={null}
    {...props}
    className={clsx(styles.workOrderDateInput, className)}
    popupClassName={clsx(styles.workOrderDatePopup, popupClassName)}
  />
);

export default WorkOrderDatePicker;
